import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

function ThirdPartyLogisticsOrdersForm(props) {

     return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "row" alignItems = {"center"}>
                <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                    <AutoComplete
                        value = {props.warehouse_options.find(option => option.value === props.warehouse) || null}
                        onChange = {(event, newValue) => {
                            props.setWarehouse(newValue ? newValue.value : null);
                        }}
                        id = "warehouse"
                        options = {props.warehouse_options}
                        getOptionLabel = {(option) => {
                            return `${option.name}`;
                        }}
                        renderOption = {(props, option) => {
                            return (
                                <li {...props}>
                                    {`${option.name}`}
                                </li>
                            );
                        }}
                        renderInput = {(params) => (
                            <TextField {...params} label = "Warehouse" />
                        )}
                    />
                </FormControl> 
                { props.warehouse ? 
                    <Button 
                        sx = {{ml: '10px'}} 
                        onClick = {() => props.get3PLInventory()} 
                        disabled = {props.isLoading} 
                        variant = "contained" 
                        color = "success" 
                    >
                        Get Inventory Levels From {(props.warehouse_options.find(option => option.value === props.warehouse))?.name}
                    </Button> 
                : null }
            </Stack>
      </Box>
    );
  };

export default ThirdPartyLogisticsOrdersForm;